import type { Category } from '@/types/comic';

export const categories: Category[] = [
  {
    key: 'romance',
    name: '恋爱',
    description: '甜宠、虐恋、契约婚约……心动与纠葛交织的浪漫故事。',
    icon: 'ri-heart-3-line',
  },
  {
    key: 'fantasy',
    name: '奇幻',
    description: '魔法、异世界、神兽与冒险，展开无限想象力的旅程。',
    icon: 'ri-magic-line',
  },
  {
    key: 'school',
    name: '校园',
    description: '青春、暗恋与友情，重回悸动纯真的校园时光。',
    icon: 'ri-graduation-cap-line',
  },
  {
    key: 'suspense',
    name: '悬疑',
    description: '层层反转与谜团，跟随线索一步步揭开真相。',
    icon: 'ri-search-eye-line',
  },
  {
    key: 'urban',
    name: '都市',
    description: '豪门、职场与逆袭，看尽人间烟火与爱恨纠葛。',
    icon: 'ri-building-2-line',
  },
  {
    key: 'action',
    name: '热血',
    description: '战斗、成长与羁绊，燃到起鸡皮疙瘩的少年热血。',
    icon: 'ri-fire-line',
  },
  {
    key: 'historical',
    name: '古风',
    description: '宫廷、江湖与古韵，一纸山河绘尽浮生旧梦。',
    icon: 'ri-ancient-gate-line',
  },
  {
    key: 'comedy',
    name: '搞笑',
    description: '沙雕日常与脑洞神展开，笑着读完一整话。',
    icon: 'ri-emotion-laugh-line',
  },
];